import {Component, EventEmitter, OnInit, Output, ViewChild} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {faPlus, faAngleDoubleLeft, faAngleDoubleRight} from "@fortawesome/free-solid-svg-icons";
import {Observable} from "rxjs";
import {Color, Lens, LensFilter, Material} from "src/app/model/catalog/catalog.model";
import {LensConfigMode, LensSide, LensType} from "src/app/model/configuration/configuration";
import {Article, ArticleType, FeatureValues, LensOrderItem} from "src/app/model/order/order";
import {CartService} from "src/app/utils/cart/cart.service";
import {LanguagePickerService} from "src/app/utils/language-picker/language-picker.service";
import {NewOrderStoreService} from "../new-order-store-service.service";
import {FinalLensComponent} from "./final-lens/final-lens.component";
import {InspectionApiService} from "../../api/inspection-api.service";
import {FinalLensRequest} from "../../model/inspection/inspection.model";
import {ItemContainer} from "../../model/return/ItemContainer";
import {ManufactureApiService} from "../../api/manufacture-api.service";
import {OrdersApiService} from "../../api/orders-api.service";

@Component({
  selector: 'app-new-order-final-lens',
  templateUrl: './new-order-final-lens.component.html',
  styleUrls: ['./new-order-final-lens.component.scss']
})
export class NewOrderFinalLensComponent implements OnInit {

  LensSide = LensSide;

  isRightSideEnable: boolean = true;
  isLeftSideEnable: boolean = true;
  isRightSideEnable$: Observable<boolean>;
  isLeftSideEnable$: Observable<boolean>;

  lensFilter: LensFilter = {};

  @ViewChild('finalLensLeft') finalLensLeft: FinalLensComponent;
  @ViewChild('finalLensRight') finalLensRight: FinalLensComponent;

  @ViewChild('plusCrossFinalLensRight') plusCrossFinalLensRight;
  @ViewChild('plusCrossFinalLensLeft') plusCrossFinalLensLeft;

  @Output() copyEmit = new EventEmitter<LensSide>();
  @Output() switchEmit = new EventEmitter<LensSide>();
  @Output() rotateEmit = new EventEmitter<boolean>();

  plusIcon = faPlus;
  arrowRight = faAngleDoubleRight;
  arrowLeft = faAngleDoubleLeft;
  remoteErrorRight: string = "";
  remoteErrorLeft: string = "";
  minDateRight: Date;
  minDateLeft: Date;

  constructor(private newOrderStoreService: NewOrderStoreService, private cartService: CartService,
              private languagePickerService: LanguagePickerService, private inspectionApi: InspectionApiService,
              private manufactureService: ManufactureApiService, private ordersApi: OrdersApiService) {
  }

  ngOnInit(): void {
    this.isRightSideEnable = this.newOrderStoreService.getIsRightSideEnable();
    this.newOrderStoreService.isRightSideEnable$.subscribe(data => {
      this.isRightSideEnable = data;
      if (this.isRightSideEnable) {
        this.plusCrossFinalLensRight.nativeElement.style.transform = 'rotate(45deg)';
      } else {
        this.discardRight();
        this.plusCrossFinalLensRight.nativeElement.style.transform = 'rotate(-1deg)';
      }
    });

    this.isLeftSideEnable = this.newOrderStoreService.getIsLeftSideEnable();
    this.newOrderStoreService.isLeftSideEnable$.subscribe(data => {
      this.isLeftSideEnable = data;
      if (this.isLeftSideEnable) {
        this.plusCrossFinalLensLeft.nativeElement.style.transform = 'rotate(45deg)';
      } else {
        this.discardLeft();
        this.plusCrossFinalLensLeft.nativeElement.style.transform = 'rotate(-1deg)';
      }
    });
  }

  async addLenses() {
    if (this.isRightSideEnable) this.finalLensRight.addLensesCheckRequiredFields();
    if (this.isLeftSideEnable) this.finalLensLeft.addLensesCheckRequiredFields();

    if (this.newOrderStoreService.getLensConfigMode() === LensConfigMode.SINGLE) {
      if (this.isRightSideEnable && this.finalLensRight.form.status === "VALID" && this.finalLensRight.lensDetailsForm.status === "VALID") {
        if (this.finalLensRight.isEditFinalLens) {
          let editLensOrderItem = this.createLensOrderItem(this.finalLensRight);
          editLensOrderItem.orderId = this.newOrderStoreService.getEditFinalLensRight().orderId;
          editLensOrderItem.orderItemId = this.newOrderStoreService.getEditFinalLensRight().orderItemId;
          await this.inspectLenses(editLensOrderItem, false);
          if (this.remoteErrorRight == "") {
            if (editLensOrderItem.orderItemId !== undefined) {
              const response = await this.ordersApi.hasPair(editLensOrderItem.orderItemId).toPromise();
              let hasPair: boolean = response.body;
              this.cartService.updateCartLensesItem(editLensOrderItem, this.finalLensRight.indexEditFinalLens, hasPair);
              if (hasPair) {
                if (this.finalLensRight.desireDate) {
                  this.finalLensRight.desireDate.setHours(12);
                }
                await this.manufactureService.solve(editLensOrderItem.orderItemId, this.toLocalDateTime(this.finalLensRight.desireDate)).toPromise();
              }
            } else {
              let lenses = [];
              await this.cartService.getCartItems().subscribe(items => lenses = items.filter(item => item.article.type == "LENS"));
              let hasPair: boolean = lenses.filter(lens => editLensOrderItem.commission == lens.commission).length > 1;
              this.cartService.updateCartLensesItem(editLensOrderItem, this.finalLensRight.indexEditFinalLens, hasPair);
              if (hasPair) {
                if (this.finalLensRight.desireDate) {
                  this.finalLensRight.desireDate.setHours(12);
                }
                this.cartService.solvePair(this.finalLensRight.desireDate, editLensOrderItem.commission);
              }
            }
            this.newOrderStoreService.setEditFinalLensRight(undefined, undefined);
            this.clearAll();
            this.finalLensRight.isEditFinalLens = undefined;
          }
        } else {
          let item = this.createLensOrderItem(this.finalLensRight);
          await this.inspectLenses(item, false);
          if (this.remoteErrorRight == "") {
            this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensRight));
            // EASE specific logic
            console.log('showEase: ', this.finalLensRight.showEase);
            console.log('isReturn: ', this.finalLensRight.isReturn);
            if (this.finalLensRight.showEase && this.finalLensRight.isReturn == false && this.finalLensRight.easeDouble) {
              this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensRight));
              console.log('Right EASE 2-pack');
            }
            this.clearAll();
            this.finalLensRight.isEditFinalLens = undefined;
          }
        }
      } else if (this.isLeftSideEnable && this.finalLensLeft.form.status === "VALID" && this.finalLensLeft.lensDetailsForm.status === "VALID") {
        if (this.finalLensLeft.isEditFinalLens) {
          let editLensOrderItem = this.createLensOrderItem(this.finalLensLeft);
          editLensOrderItem.orderId = this.newOrderStoreService.getEditFinalLensLeft().orderId;
          editLensOrderItem.orderItemId = this.newOrderStoreService.getEditFinalLensLeft().orderItemId;
          await this.inspectLenses(editLensOrderItem, true);
          if (this.remoteErrorLeft == "") {
            if (editLensOrderItem.orderItemId !== undefined) {
              const response = await this.ordersApi.hasPair(editLensOrderItem.orderItemId).toPromise();
              let hasPair: boolean = response.body;
              this.cartService.updateCartLensesItem(editLensOrderItem, this.finalLensLeft.indexEditFinalLens, hasPair);
              if (hasPair) {
                if (this.finalLensLeft.desireDate) {
                  this.finalLensLeft.desireDate.setHours(12);
                }
                await this.manufactureService.solve(editLensOrderItem.orderItemId, this.toLocalDateTime(this.finalLensLeft.desireDate)).toPromise();
              }
            } else {
              let lenses = [];
              await this.cartService.getCartItems().subscribe(items => lenses = items.filter(item => item.article.type == "LENS"));
              let hasPair: boolean = lenses.filter(lens => editLensOrderItem.commission == lens.commission).length > 1;
              this.cartService.updateCartLensesItem(editLensOrderItem, this.finalLensLeft.indexEditFinalLens, hasPair);
              if (hasPair) {
                if (this.finalLensLeft.desireDate) {
                  this.finalLensLeft.desireDate.setHours(12);
                }
                this.cartService.solvePair(this.finalLensLeft.desireDate, editLensOrderItem.commission);
              }
            }
            this.newOrderStoreService.setEditFinalLensLeft(undefined, undefined);
            this.clearAll();
            this.finalLensLeft.isEditFinalLens = undefined;
          }
        } else {
          let item = this.createLensOrderItem(this.finalLensLeft);
          await this.inspectLenses(item, true);
          if (this.remoteErrorLeft == "") {
            this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensLeft));
            // EASE specific logic
            console.log('showEase: ', this.finalLensLeft.showEase);
            console.log('isReturn: ', this.finalLensLeft.isReturn);
            if (this.finalLensLeft.showEase && this.finalLensLeft.isReturn == false && this.finalLensLeft.easeDouble) {
              this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensLeft));
              console.log('Left EASE 2-pack');
            }
            this.clearAll();
            this.finalLensLeft.isEditFinalLens = undefined;
          }
        }
      }

    } else if (this.finalLensRight.form.status === "VALID" && this.finalLensRight.lensDetailsForm.status === "VALID" && this.finalLensLeft.form.status === "VALID" && this.finalLensLeft.lensDetailsForm.status === "VALID") {
      await this.inspectLenses(this.createLensOrderItem(this.finalLensRight), false);
      await this.inspectLenses(this.createLensOrderItem(this.finalLensLeft), true);
      if (this.remoteErrorRight == "" && this.remoteErrorLeft == "") {
        let warning: boolean = false;

        if (!this.finalLensRight.desireDate && this.finalLensLeft.desireDate) {
          this.finalLensLeft.desireDate.setHours(12);
          await this.calculateProductionDate(this.finalLensRight, false);
          this.finalLensRight.desireDate = new Date();
          if (this.minDateRight) {
            this.finalLensRight.desireDate.setTime(this.minDateRight.getTime());
          }
        }

        if (!this.finalLensLeft.desireDate && this.finalLensRight.desireDate) {
          this.finalLensRight.desireDate.setHours(12);
          await this.calculateProductionDate(this.finalLensLeft, true);
          this.finalLensLeft.desireDate = new Date();
          if (this.minDateLeft) {
            this.finalLensLeft.desireDate.setTime(this.minDateLeft.getTime());
          }
        }

        if (this.finalLensRight.desireDate && this.finalLensLeft.desireDate) {
          warning = this.finalLensRight.desireDate.getTime() != this.finalLensLeft.desireDate.getTime();
          if (warning) {
            if (this.finalLensRight.desireDate > this.finalLensLeft.desireDate) {
              this.finalLensLeft.desireDate.setTime(this.finalLensRight.desireDate.getTime() + 60000);
            } else if (this.finalLensRight.desireDate < this.finalLensLeft.desireDate) {
              this.finalLensRight.desireDate.setTime(this.finalLensLeft.desireDate.getTime() + 60000);
            }
          }
        }
        this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensRight), warning);
        if (this.finalLensRight.showEase && this.finalLensRight.isReturn == false && this.finalLensRight.easeDouble) {
          this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensRight), warning);
          console.log('Right EASE 2-pack');
        }
        this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensLeft), warning);
        if (this.finalLensLeft.showEase && this.finalLensLeft.isReturn == false && this.finalLensLeft.easeDouble) {
          this.cartService.addCartLensesItem(this.createLensOrderItem(this.finalLensLeft), warning);
          console.log('Left EASE 2-pack');
        }
        this.clearAll();
      }
    }
  }

  toLocalDateTime(newDate: Date) {
    if (newDate) {
      return newDate.toISOString().replace('T', ' ').substring(0, 19);
    } else {
      return '';
    }
  }

  async calculateProductionDate(lens: FinalLensComponent, isLeft: boolean) {
    let family = lens.form.controls['lensFamily'].value;
    let material = lens.form.controls['material'].value;
    let prism = lens.lensDetailsForm.contains('Prism') ? lens.lensDetailsForm.controls['Prism'].value : '';
    const response = await this.manufactureService.calculate([family, material, prism]).toPromise();
    if (isLeft) {
      this.minDateLeft = new Date(response.body.year, response.body.month - 1, response.body.day + 1, 12);
    } else {
      this.minDateRight = new Date(response.body.year, response.body.month - 1, response.body.day + 1, 12);
    }
  }

  async inspectLenses(item: LensOrderItem, isLeft: boolean) {
    let errorResponse;
    let itemContainer: ItemContainer = {
      commission: item.commission,
      side: item.side,
      lensType: item.article.lensType,
      backSide: item.article.backSide ? item.article.backSide.id : 0,
      lensFamily: item.article.id,
      material: item.material.id,
      color: item.color.id,
      isReturn: item.isReturn,
      featureValues: item.featureValues
    };
    let request: FinalLensRequest = new FinalLensRequest(itemContainer);
    const response = await this.inspectionApi.inspectFinalLens([request]).toPromise();
    errorResponse = JSON.parse(response.toString().replace('[', '').replace(']', ''));
    if (errorResponse.errorCode == 0) {
      if (isLeft) {
        this.remoteErrorLeft = "";
      } else {
        this.remoteErrorRight = "";
      }
    } else {
      if (errorResponse.errorDescription) {
        if (isLeft) {
          this.remoteErrorLeft = errorResponse.errorDescription.replaceAll(';', '\n');
        } else {
          this.remoteErrorRight = errorResponse.errorDescription.replaceAll(';', '\n');
        }
      }
    }
  }

  discard() {
    if (this.isRightSideEnable) {
      this.discardRight();
    }
    if (this.isLeftSideEnable) {
      this.discardLeft();
    }
  }

  discardRight() {
    this.finalLensRight.clearAll();
  }

  discardLeft() {
    this.finalLensLeft.clearAll();
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }

  private clearAll() {
    this.finalLensRight.clearAll();
    this.finalLensLeft.clearAll();
    this.newOrderStoreService.setCopyFinalLensLeft(undefined);
    this.newOrderStoreService.setCopyFinalLensRight(undefined);
    this.finalLensRight.copyFinalLens = {featureValues: {}};
    this.finalLensLeft.copyFinalLens = {featureValues: {}};
  }

  private createLensOrderItem(component: any): LensOrderItem {
    return {
      commission: this.getCommission(component.form),
      desireDate: this.fixTimeZone(component.desireDate),
      article: this.getArticle(component.lensFilter.families, component.form.controls['lensFamily'].value, component.form.controls['lensType'].value),
      count: 1,
      material: this.getMaterial(component.lensFilter.materials, component.form.controls['material'].value),
      color: this.getColor(component.lensFilter.colors, component.form.controls['color'].value),
      featureValues: this.getFeaturesValues(component.lensDetailsForm),
      isReturn: component.isReturn,
      isIndividual: component.isIndividual,
      side: component.side,
      isNew: true,
      isUpdate: false
    }
  }

  private fixTimeZone(date: Date) {
    if (date != null) {
      if (date.getMinutes() == 1) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12, 1);
      } else {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12);
      }
    }
  }

  private getFeaturesValues(form: FormGroup): FeatureValues {
    let featureValues: FeatureValues = {};
    Object.keys(form.controls).forEach(key => {
      let value = (form.controls[key].value !== '') ? form.controls[key].value : null;
      value = (Number.isNaN(value)) ? form.controls[key].value : value;
      featureValues[key] = value;
    });
    return featureValues;
  }

  private getCommission(form: FormGroup): string {
    return form.controls['commission'].value;
  }

  private getArticle(lenses: Lens[], lensName: string, lensType: string): Article {
    return {
      type: ArticleType.LENS,
      id: lenses.find(lens => lens.name === lensName).id,
      name: lensName,
      lensType: (lensType === LensType.HARD) ? LensType.HARD : LensType.SOFT
    }
  }

  private getMaterial(materials: Material[], materialName: string): Material {
    return materials.find(material => material.name === materialName);
  }

  private getColor(colors: Color[], colorName: string): Color {
    return colors.find(color => color.name === colorName);
  }

  togglePlusFinalLensRightSide() {
    this.remoteErrorRight = "";
    this.newOrderStoreService.toggleIsRightSideEnable();
    this.newOrderStoreService.toggleLensConfigMode();
    if (this.isRightSideEnable) {
      this.plusCrossFinalLensRight.nativeElement.style.transform = 'rotate(45deg)';
    } else {
      this.plusCrossFinalLensRight.nativeElement.style.transform = 'rotate(-1deg)';
    }
  }

  togglePlusFinalLensLeftSide() {
    this.remoteErrorLeft = "";
    this.newOrderStoreService.toggleIsLeftSideEnable();
    this.newOrderStoreService.toggleLensConfigMode();
    if (this.isLeftSideEnable) {
      this.plusCrossFinalLensLeft.nativeElement.style.transform = 'rotate(45deg)';
    } else {
      this.plusCrossFinalLensLeft.nativeElement.style.transform = 'rotate(-1deg)';
    }
  }

  copy(sideFrom: LensSide) {
    this.copyEmit.emit(sideFrom);
  }

  switch(sideFrom: LensSide) {
    this.switchEmit.emit(sideFrom);

    this.newOrderStoreService.toggleIsRightSideEnable(true);
    this.newOrderStoreService.toggleIsLeftSideEnable(true);

    if (sideFrom === LensSide.RIGHT) {
      this.plusCrossFinalLensRight.nativeElement.style.transform = 'rotate(-1deg)';
      this.plusCrossFinalLensLeft.nativeElement.style.transform = 'rotate(45deg)';
    } else if (sideFrom === LensSide.LEFT) {
      this.plusCrossFinalLensLeft.nativeElement.style.transform = 'rotate(-1deg)';
      this.plusCrossFinalLensRight.nativeElement.style.transform = 'rotate(45deg)';
    }
  }

  rotateLens() {
    let isDual: boolean = this.isRightSideEnable && this.isLeftSideEnable;
    this.rotateEmit.emit(isDual);
  }
}
